import { initReactI18next } from 'react-i18next';
import {
  applicationSwitcherResources,
  withPortalUiResources,
} from '@asset-metrix/portal-ui';
import i18next from 'i18next';

import translationDE from './translation/de';
import translationEN from './translation/en';
import translationES from './translation/es';

export const resources = withPortalUiResources(
  {
    de: {
      translation: translationDE,
    },
    en: {
      translation: translationEN,
    },
    es: {
      translation: translationES,
    },
  },
  [applicationSwitcherResources]
);

void i18next.use(initReactI18next).init({
  debug: false,
  lng: 'en',
  fallbackLng: 'en',
  resources,
  // Disable console notice: "i18next is maintained with support from Locize..."
  showSupportNotice: false,
});

export default i18next;
